import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { Box, Container } from "@mui/material";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useEffect, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { TableTabs } from "../../../../../components/TableTabs/Index";
import EditProject from "../DetailsProject/EditProject";
import CategorizationsProject from "../CategorizationsProject";
import LearningObjectProject from "../LearningObjectProject";
import ContextProject from "../ContextProject";
import CostProject from "../CostProject";
import ButtonBackPage from "@components/ButtonBackPage";
import { useLocation } from "react-router-dom";

const DetailProject: React.FC = () => {
  const { t } = useTranslation(["projects-page"]);
  const { idProject } = useParams();
  const [selectedTab, setSelectedTab] = useState(0);
  const [newTab, setNewTab] = useState<number | undefined>();
  const location = useLocation();
  const defaultTab = location.state?.tab;

  const { dataDetail } = useFetchDetail(
    `${ServicesURL.getProjects}`,
    idProject,
    PagesID["projects"],
  );

  useEffect(() => {
    switch (defaultTab) {
      case "lo":
        setNewTab(2);
        break;
      case "costs":
        setNewTab(4);
        break;
    }
  }, [defaultTab]);

  const tabs = [
    {
      [t("tab.details")]: <EditProject />,
    },
    {
      [t("tab.context")]: <ContextProject />,
    },
    {
      [t("tab.learning_object")]: <LearningObjectProject />,
    },
    {
      [t("tab.categorizations")]: <CategorizationsProject />,
    },
    {
      [t("tab.costs")]: <CostProject />,
    },
  ];

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-project.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={
            dataDetail && dataDetail.dto
              ? `${dataDetail.dto.code ? dataDetail.dto.code : ""} - ${dataDetail.dto.title ? dataDetail.dto.title : ""}`
              : ""
          }
          description={t("edit.hero-description")}
        />
        <ButtonBackPage />
        <TableTabs
          setExternalSelectedTab={setSelectedTab}
          tabs={tabs}
          goToTab={newTab}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default DetailProject;
